import { useState } from 'react';

import type { PrivateEventDetail } from '../../api/privateEvents';

import AddOnsNotesSection from './AddOnsNotesSection';
import ClientDealSection from './ClientDealSection';
import { usePrivateEventEditAccess } from './use-private-event-edit-access';
import WhenWhatSection from './WhenWhatSection';

/**
 * The details card: three sections that each read as a record and flip to a
 * form on Edit. A 403 from any save turns every section read-only, because the
 * viewer's access, not that one section, has changed.
 */
export default function PrivateEventDetailsCard({ event }: { event: PrivateEventDetail }) {
  const canEdit = usePrivateEventEditAccess(event.regionId);
  const [denied, setDenied] = useState(false);
  const readOnly = !canEdit;
  const onDenied = () => setDenied(true);
  return (
    <div className="nb-card" style={{ padding: '2px 18px 14px' }}>
      {denied && (
        <p
          role="alert"
          style={{ margin: '12px 0 0', fontSize: 12, color: 'var(--nb-risk)', lineHeight: 1.45 }}
        >
          You no longer have permission to edit this event, so it is now read-only.
        </p>
      )}
      <WhenWhatSection event={event} readOnly={readOnly} denied={denied} onDenied={onDenied} />
      <ClientDealSection event={event} readOnly={readOnly} denied={denied} onDenied={onDenied} />
      <AddOnsNotesSection event={event} readOnly={readOnly} denied={denied} onDenied={onDenied} />
    </div>
  );
}
